import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILMATERIALACOUNT,
  DELETE_CIVILMATERIALACOUNT,
  UPDATE_CIVILMATERIALACOUNT,
  ADD_NEW_CIVILMATERIALACOUNT,
} from "./actionType";

import {
  getCivilAccountSuccess,
  getCivilAccountFail,
  deleteCivilAccountSuccess,
  deleteCivilAccountFail,
  updateCivilAccountSuccess,
  updateCivilAccountFail,
  addCivilAccountSuccess,
  addCivilAccountFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilAccountApi,
  updateCivilAccountApi,
  deleteCivilAccountApi,
  addNewCivilAccountApi,
  approveCivilAccountApi
} from "../../helpers/backend_helper";

function* getCivilAccount({ payload: civilAccount }) {
  try {
    const response = yield call(getCivilAccountApi, civilAccount);
    yield put(getCivilAccountSuccess(GET_CIVILMATERIALACOUNT, response.data));
  } catch (error) {
    yield put(getCivilAccountFail(GET_CIVILMATERIALACOUNT, error));
  }
}

function* onUpdateCivilAccount({ payload: civilAccount }) {
  try {
    if (civilAccount.setApprove) {
      const response = yield call(approveCivilAccountApi, civilAccount);
      yield put(updateCivilAccountSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilAccountApi, civilAccount);
      yield put(updateCivilAccountSuccess(response));
      toast.success(updateCivilAccountSuccess.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilAccountFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilAccount({ payload: civilAccount }) {
  try {
    const response = yield call(deleteCivilAccountApi, civilAccount);
    yield put(deleteCivilAccountSuccess({ civilAccount, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilAccountFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilAccount({ payload: civilAccount }) {
  try {
    const response = yield call(addNewCivilAccountApi, civilAccount);
    yield put(addCivilAccountSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilAccountFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilAccount() {
  yield takeEvery(GET_CIVILMATERIALACOUNT, getCivilAccount);
}

export function* watchUpdateCivilAccount() {
  yield takeEvery(UPDATE_CIVILMATERIALACOUNT, onUpdateCivilAccount);
}

export function* watchDeleteCivilAccount() {
  yield takeEvery(DELETE_CIVILMATERIALACOUNT, onDeleteCivilAccount);
}

export function* watchAddNewCivilAccount() {
  yield takeEvery(ADD_NEW_CIVILMATERIALACOUNT, onAddNewCivilAccount);
}

function* civilAccountSaga() {
  yield all([
    fork(watchGetCivilAccount),
    fork(watchDeleteCivilAccount),
    fork(watchUpdateCivilAccount),
    fork(watchAddNewCivilAccount)
  ]);
}

export default civilAccountSaga;
